import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import _ from "lodash/fp";

const nabVelocityURL = process.env.REACT_APP_NAB_VELOCITY_URL;

const PaymentButton = ({
  title,
  callbackFunction,
  disabled,
  terminalProfileId,
  amount,
  email,
  billingName
}) => {
  useEffect(() => {
    window.onProcessPayment = callbackFunction;
    const scriptExists = _.find(
      script => script.src === nabVelocityURL,
      document.getElementsByTagName("script")
    );
    if (!scriptExists) {
      const script = document.createElement("script");
      script.onload = function() {
        if (window.Velocity) {
          window.Velocity.autoinit();
        }
      };
      script.src = nabVelocityURL;
      document.body.appendChild(script);
    }
    return () => {
      window.onProcessPayment = null;
    };
  }, [callbackFunction]);
  return (
    <Fragment>
      <button
        disabled={disabled}
        className="btn btn-primary btn-fill velocity-button btn-payment"
        data-terminal-profile-id={terminalProfileId}
        data-amount={amount}
        data-email={email}
        data-billing-name={billingName}
        data-callback-function="onProcessPayment"
      >
        {title}
      </button>
    </Fragment>
  );
};

PaymentButton.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.element.isRequired
  ])
};

export default PaymentButton;
